import { jsx } from "react/jsx-runtime";
import { TPAComponentsProvider } from "@wix/wix-ui-tpa/cssVars";
import { useMemo } from "react";
const Providers = ({
  children,
  config
}) => {
  const tpa = useMemo(
    () => ({
      mobile: config.isMobile,
      rtl: config.isRTL
    }),
    [config.isMobile, config.isRTL]
  );
  return /* @__PURE__ */ jsx(TPAComponentsProvider, { value: tpa, children });
};
export {
  Providers as default
};
//# sourceMappingURL=providers.js.map
